module.exports = __webpack_public_path__ + "static/media/img-3.e8d062a1.jpg";